/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useState, useRef } from "react";
import { Tabs, Tab, TabList, TabPanel } from "react-tabs";
import classnames from "classnames";
import "react-tabs/style/react-tabs.css";
import useBaseInfo from "../store/useBaseInfo";
import useBasicFormData from "../store/useBasicFormData";
import useSelfArrivalCity from "../store/useSelfArrivalCity";
import useCitiesData from "../store/useCitiesData";
import usePickupAddress from "../store/usePickupAddress";
import useAppLocationData from "../store/useAppLocationData";
import request from "../../../network/request";
import ReserveByDatePanel from "../components/ReserveByDatePanel";
import ReserveByStorePanel from "../components/ReserveByStorePanel";
import { getLocationFromApp } from "../common/funcs";
import {
  DEFAULT_CITY_CODE,
  STORE_TIME_TAB_LIST,
  TAB_ID_SET,
} from "../config/constants";
import { getHumanizeDateText } from "../../../utils/date";
import { convertAdcode } from "../../../utils/common";
import { CommonLoadingComp } from "../../../components/CommonLoading";
import EmptyPlaceHolder from "../components/EmptyPlaceHolder";
import UnsupportCityHolder from "../components/UnsupportCityHolder";
import { sendReport } from "../../../utils/reporter";
import dayjs from "dayjs";
import "./indexV2.scss";
import { ErrorPlaceholder } from "../../../components/placeholder";
import { findServiceItemsParam } from "../utils";
import { ReservationItemTypes } from "../interfaces/home";

export interface StoreAndTimeSelectorProps {
  reserveItems: ReservationItemTypes[];
}

export default function StoreAndTimeSelector(props: StoreAndTimeSelectorProps) {
  const { reserveItems = [] } = props;
  const { baseInfo, setContentEdited } = useBaseInfo();
  const {
    basicFormData,
    setStoreTimeTabIndex,
    setStoreContentOfStoreTab,
    setDatesContentOfStoreTab,
    setArriveStoreTimeData,
    setContactInfoData,
  } = useBasicFormData();
  const { resetPickupAddress } = usePickupAddress();
  const { setAppLocationData, appLocationData } = useAppLocationData();
  const [isLoading, setIsLoading] = useState(true);
  const { selfArrivalCity, setSelfArrivalCity } = useSelfArrivalCity();
  const { data: provincesCitiesData } = useCitiesData();
  const [locationMsg, setLocationMsg] = useState<any>({});
  const loadingShopListRef = useRef(false);
  const [loadShopListEnded, setLoadShopListEnded] = useState(false);
  const [isUnsupportCity, setIsUnsupportCity] = useState(false);
  const loadingShopCapacityRef = useRef(false);
  const [showEmpty, setShowEmpty] = useState(false);
  const [isError, setIsError] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  const getCityWithLocation = useCallback(() => {
    const code = parseInt(locationMsg?.data?.adCode);
    const [provinceCode, cityCode] = convertAdcode(code);
    let province = "";
    let city = "";
    let matchingCityCode: any = 0;
    let matchingProvinceCode: any = 0;

    provincesCitiesData?.forEach((provinceItem) => {
      if (`${provinceItem.value}` === `${provinceCode}`) {
        matchingProvinceCode = provinceItem.value;
        provinceItem.children.forEach((cityItem) => {
          // 兼容数据库中 上海 的citycode只有两位的情况
          if (`${cityItem.value}` === `${provinceCode}`) {
            matchingCityCode = provinceItem.value;
            city = cityItem.label;
            province = provinceItem.label;
          }
          if (`${cityItem.value}` === `${cityCode}`) {
            matchingCityCode = cityItem.value;
            city = cityItem.label;
            province = provinceItem.label;
          }
        });
      }
    });
    // 处理位置信息
    let tmp = {
      cityCode: matchingCityCode + "",
      province,
      city,
    };
    localStorage.setItem("__das_es_location", JSON.stringify(tmp));
    console.log(tmp, "存储定位获取的地址信息，localtionStorge");
    // 找不到匹配城市（当前城市不支持维保）
    if (matchingCityCode === 0) {
      setIsLoading(false);
      setIsUnsupportCity(true);
    }
    setSelfArrivalCity({
      cityCode: matchingCityCode,
      cityName: city,
      provinceCode: matchingProvinceCode,
      provinceName: province,
      address: locationMsg?.data?.address,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [provincesCitiesData, locationMsg]);

  /**获取定位失败时需要先获取专属门店及城市，如果没有才默认广州 */
  const queryExclusiveShop = useCallback(async () => {
    try {
      const rsp: any = await request(
        "/public/v2/shop/getDefaultShopAndCity",
        {
          vin: baseInfo.frameNumber,
        },
        "POST",
        {
          useCustomUrl: true,
        }
      );

      if (rsp.cityCode) {
        setSelfArrivalCity({
          cityCode: rsp.cityCode,
          cityName: rsp.cityName,
          address: "",
        });
      } else {
        console.log(
          "获取专属门店失败",
          rsp,
          "\n 设置adCode为默认 DEFAULT_CITY_CODE",
          DEFAULT_CITY_CODE
        );
        setLocationMsg({
          data: {
            adCode: DEFAULT_CITY_CODE,
          },
        });
      }
    } catch (e) {
      console.log(
        "获取专属门店错误",
        "\n 设置adCode为默认 DEFAULT_CITY_CODE",
        DEFAULT_CITY_CODE
      );
      setLocationMsg({
        data: {
          adCode: DEFAULT_CITY_CODE,
        },
      });
    }
  }, [baseInfo.frameNumber]);

  useEffect(() => {
    if ((selfArrivalCity && selfArrivalCity.cityCode) || isUnsupportCity) {
      // 假设没 app 定位，则取再一次（修改流程会直接先设置 selfArrivalCity）
      if (!appLocationData) {
        getLocationFromApp()
          .then((res: any) => {
            if (!res) return;
            const appLocData = res.data;
            setAppLocationData(appLocData);
          })
          .catch(() => {
            console.log("获取定位失败");
          });
      }
      return;
    }
    // getProvinceAndCity();
    const st = Date.now();
    getLocationFromApp()
      .then((res: any) => {
        const now = Date.now();
        console.info(
          "获取定位成功且耗时为getLocationFromApp：：：：：：",
          (now - st) / 1000,
          "s"
        );
        if (!res) return;
        setLocationMsg(res);
        const appLocData = res.data;
        setAppLocationData(appLocData);
      })
      .catch((res) => {
        const now = Date.now();
        console.info("获取定位失败耗时为：：：：", (now - st) / 1000, "s");
        queryExclusiveShop();
      });
  }, [selfArrivalCity, isUnsupportCity, appLocationData, queryExclusiveShop]);

  useEffect(() => {
    // console.log('!!准备设置定位关信息， provincesCitiesData.length =', provincesCitiesData.length, 'locationMsg?.data?.adCode=', locationMsg, locationMsg?.data?.adCode)
    if (provincesCitiesData?.length !== 0 && locationMsg?.data?.adCode) {
      getCityWithLocation();
    }
  }, [provincesCitiesData, locationMsg, getCityWithLocation]);

  // tab 点击事件处理
  const onTabChangeHandler = (tabItem) => {
    const tabIndex = tabItem.id;
    setStoreTimeTabIndex(tabIndex);
    if (tabIndex === TAB_ID_SET.STORE_TAB) {
      sendReport({
        mcode: "按门店tab点击",
        point: "P11183`B008",
      });
    }
    if (tabIndex === TAB_ID_SET.DATE_TAB) {
      sendReport({
        mcode: "按日期tab点击",
        point: "P11183`B009",
      });
    }
  };

  const getShopListByCityCode = useCallback(
    async (cityCode) => {
      try {
        const locationItem = JSON.parse(
          localStorage.getItem("current_lng_and_lat") || "{}"
        );
        // 获取 serviceItems 参数
        const { serviceItems, eventCode, repairDescList } = findServiceItemsParam(reserveItems);
        const shopListRsp: any = await request(
          "/public/v2/module/maintenance/v2/shop/listShop",
          {
            cityCode,
            vin: baseInfo.frameNumber,
            lng: locationItem?.longitude ?? null,
            lat: locationItem?.latitude ?? null,
            serviceItems,
            eventCode,
            childServiceItems: repairDescList,
          },
          "POST",
          {
            useCustomUrl: true,
          }
        );
        const shopList = shopListRsp.filter((item) => !item.groupFive);
        if (shopList.length > 0) {
          // setUsingStoreByStoreTab(shopList[0]);
          if (basicFormData.storeTimeStepData.modifyOrderShopCode) {
            const targetShop =
              shopList.filter(
                (shopItem) =>
                  shopItem.code ===
                  basicFormData.storeTimeStepData.modifyOrderShopCode
              )[0] || shopList[0];
            setStoreContentOfStoreTab(targetShop);
          } else {
            setStoreContentOfStoreTab(shopList[0]);
          }
        } else {
          setStoreContentOfStoreTab(null);
          setArriveStoreTimeData(null);
        }
      } catch (e) {
        setIsError(true);
        setErrorMsg(e.message);
      } finally {
        setIsLoading(false);
        setLoadShopListEnded(true);
        loadingShopListRef.current = false;
      }
    },
    [
      baseInfo,
      basicFormData.storeTimeStepData.modifyOrderShopCode,
      reserveItems,
      setStoreContentOfStoreTab,
    ]
  );

  // 获取每天可预约的总容量
  const getDateReserveNumber = (items) => {
    return items.reduce((total, next) => {
      const quota = next.canReserveNumber >= 0 ? next.canReserveNumber : 0;
      return total + quota;
    }, 0);
  };

  const processedDatesContent = (dates, defaultTimestamp) => {
    if (!dates || dates.length === 0) return [];
    let isSetDefault = false;
    let dateKey = "";
    let hourminuteKey = "";
    if (defaultTimestamp) {
      dateKey = dayjs(defaultTimestamp).format("YYYY-MM-DD");
      hourminuteKey = dayjs(defaultTimestamp).format("HH:mm");
    }

    let matchDefaultTarget: any = null;
    let matchingRuleItem: any = null;
    let checkedDefaultTimeOption = false;
    let allDatesQuota = 0;

    const rangeList = dates.map((dateItem) => {
      const { timestamp } = dateItem;
      const dayObj = dayjs(timestamp);
      const curDateKey = dayObj.format("YYYY-MM-DD");

      const reserveQuota = dateItem.ruleItems
        ? getDateReserveNumber(dateItem.ruleItems)
        : 0;
      let isChecked = false;
      if (curDateKey === dateKey) {
        isChecked = true;
      }
      isChecked = !isSetDefault && !dateKey ? reserveQuota > 0 : isChecked;
      isSetDefault = isSetDefault || isChecked;
      // 默认选中了日期
      if (isChecked) {
        matchDefaultTarget = dateItem;
      }
      return {
        ...dateItem,
        reserveQuota,
        checked: isChecked,
        weekDate: getHumanizeDateText(dayObj),
        dateDesc: dayObj.format("MM/DD"),
        ruleItems: dateItem.ruleItems.map((ruleItem) => {
          let checkedOption = false;
          // 当前项是否匹配默认日期
          const isMatchDefaultDate =
            !!hourminuteKey &&
            ruleItem.startTime === hourminuteKey &&
            ruleItem.canReserveNumber > 0;
          // 修改匹配
          if (!!hourminuteKey) {
            matchingRuleItem = isMatchDefaultDate ? ruleItem : matchingRuleItem;
          } else if (
            !checkedDefaultTimeOption &&
            ruleItem.canReserveNumber > 0
          ) {
            // 设置第一个有容量的 time option
            checkedDefaultTimeOption = true;
            checkedOption = true;
            matchingRuleItem = ruleItem;
          }
          allDatesQuota += reserveQuota;
          return {
            ...ruleItem,
            checked: isMatchDefaultDate || checkedOption,
          };
        }),
      };
    });

    // console.log('按门店自动选择 matchDefaultTarget ???? ', matchDefaultTarget, defaultTimestamp);
    // console.log('按门店自动选择 matchingRuleItem ???? ', matchingRuleItem);
    if (matchingRuleItem && matchDefaultTarget) {
      setArriveStoreTimeData({
        timestamp: defaultTimestamp || matchDefaultTarget.timestamp,
        // weekDate: target.weekDate,
        date: matchDefaultTarget.date,
        startTime: matchingRuleItem ? matchingRuleItem.startTime : "",
      });
    } else {
      setArriveStoreTimeData(null);
    }

    setShowEmpty(allDatesQuota === 0);

    // 编辑模式下，不重置，编辑过则重置
    // console.log('编辑模式下，不重置，编辑过则重置: ', !baseInfo.isEditingMode, baseInfo.contentEdited)
    if (!baseInfo.isEditingMode || baseInfo.contentEdited) {
      // 重置取送车时间
      setContactInfoData({
        pickupServiceTime: "",
      });
      resetPickupAddress();
    }
    return rangeList;
  };

  const getCapacityByShopCode = useCallback(
    async (shopCode) => {
      try {
        const locationItem = JSON.parse(
          localStorage.getItem("current_lng_and_lat") || "{}"
        );
        // 获取 serviceItems 参数
        const { serviceItems, eventCode } = findServiceItemsParam(reserveItems);
        const listShopCapacity: any = await request(
          "/public/v2/module/maintenance/v2/shop/listShopCapacity",
          {
            shopCode,
            vin: baseInfo.frameNumber,
            reserveId: baseInfo.reserveId || "",
            lng: locationItem?.longitude ?? null,
            lat: locationItem?.latitude ?? null,
            serviceItems,
            eventCode,
          },
          "POST",
          {
            useCustomUrl: true,
          }
        );
        // 门店不可用，则不处理数据
        if (!listShopCapacity.groupFive) {
          const datesListWithState = processedDatesContent(
            listShopCapacity.dates,
            basicFormData.storeTimeStepData.modifyOrderArriveTime
          );
          console.log(
            "getCapacityByShopCode 门店不可用，则不处理数据",
            datesListWithState
          );
          setDatesContentOfStoreTab(datesListWithState);
        }
      } catch (e) {
        setIsError(true);
        setErrorMsg(e.message);
      } finally {
        setIsLoading(false);
        loadingShopCapacityRef.current = false;
      }
    },
    [
      baseInfo.frameNumber,
      baseInfo.reserveId,
      basicFormData.storeTimeStepData.modifyOrderArriveTime,
      reserveItems,
      processedDatesContent,
      setDatesContentOfStoreTab,
    ]
  );

  const init = useCallback(() => {
    // 通过 cityCode 获取门店列表
    if (
      !selfArrivalCity ||
      !selfArrivalCity.cityCode ||
      basicFormData.storeTimeStepData.storeDataByStoreTab ||
      loadingShopListRef.current ||
      loadShopListEnded
    ) {
      return;
    }
    const { cityCode } = selfArrivalCity;
    setIsLoading(true);
    loadingShopListRef.current = true;
    getShopListByCityCode(cityCode);
  }, [
    loadShopListEnded,
    basicFormData.storeTimeStepData.storeDataByStoreTab,
    selfArrivalCity,
    getShopListByCityCode,
  ]);

  useEffect(init, [init]);

  useEffect(() => {
    // 没有 storeData return
    if (
      !basicFormData.storeTimeStepData.storeDataByStoreTab ||
      loadingShopCapacityRef.current
    )
      return;

    const { code: shopCode } =
      basicFormData.storeTimeStepData.storeDataByStoreTab;
    // 已有 reserveDateDataByStoreTab
    if (!basicFormData.storeTimeStepData.reserveDateDataByStoreTab) {
      // 通过 shopCode 请求容量信息
      setIsLoading(true);
      loadingShopCapacityRef.current = true;
      getCapacityByShopCode(shopCode);
    } else {
      setIsLoading(false);
    }
  }, [
    basicFormData.storeTimeStepData.storeDataByStoreTab,
    basicFormData.storeTimeStepData.reserveDateDataByStoreTab,
  ]);

  // 日期/时间option 切换
  const onDateItemChangeHandler = (data) => {
    const { dateItem: target, timeOptionKey, startTime } = data;

    let matchingRuleItem: any = null;
    const curDatesList =
      basicFormData.storeTimeStepData?.reserveDateDataByStoreTab || [];
    const updatedDatesList = curDatesList.map((dateItem) => {
      let checkedOption = false;
      const checkedDate = dateItem.date === target.date;
      return {
        ...dateItem,
        // key: Date.now(),
        checked: checkedDate,
        ruleItems: dateItem.ruleItems.map((ruleItem) => {
          const { date, startTime: curStartTime, canReserveNumber } = ruleItem;
          // 有选中 option
          if (timeOptionKey) {
            const dhm = `${date}-${curStartTime}`;
            return {
              ...ruleItem,
              checked: dhm === timeOptionKey,
            };
          }

          // 切换日期，选中默认 option
          const isCheckedOption =
            !checkedOption && canReserveNumber > 0 && checkedDate;
          checkedOption = checkedOption || isCheckedOption;
          if (isCheckedOption) {
            matchingRuleItem = ruleItem;
          }
          return {
            ...ruleItem,
            checked: isCheckedOption,
          };
        }),
      };
    });
    // console.log('updatedDatesList .................?>', updatedDatesList);
    setDatesContentOfStoreTab(updatedDatesList);

    const st =
      startTime || (matchingRuleItem ? matchingRuleItem.startTime : "");
    // 设置选中日期及时间
    setArriveStoreTimeData({
      timestamp: target.timestamp,
      weekDate: target.weekDate,
      date: target.date,
      startTime: st,
    });
    // 重置取送车时间
    setContactInfoData({
      pickupServiceTime: "",
    });
    resetPickupAddress();
    setContentEdited(true);
  };

  const reload = useCallback(() => {
    setIsError(false);
    setErrorMsg("");
    setLoadShopListEnded(false);
    init();
  }, [init]);

  return (
    <div className="store-time-container">
      <Tabs
        id="custom-nav-comp"
        selectedIndex={
          /**reserveType 的值和这里的 TAB_Item的 key 值默认对应，修改时需要注意 */
          basicFormData.storeTimeStepData.reserveType
        }
        selectedTabClassName="active"
        onSelect={() => {}}
        forceRenderTabsPanel
      >
        <TabList>
          <div className="tab-list">
            {STORE_TIME_TAB_LIST.map((tabItem) => {
              return (
                <Tab key={tabItem.id}>
                  <div
                    className={classnames("tab-item", {
                      "selected-tab":
                        tabItem.id ===
                        basicFormData.storeTimeStepData?.reserveType,
                    })}
                    onClick={() => onTabChangeHandler(tabItem)}
                  >
                    {tabItem.name}
                  </div>
                </Tab>
              );
            })}
          </div>
        </TabList>
        <TabPanel key={STORE_TIME_TAB_LIST[0].id} forceRender>
          {isUnsupportCity ? <UnsupportCityHolder /> : <ReserveByDatePanel reserveItems={reserveItems} />}
        </TabPanel>
        <TabPanel key={STORE_TIME_TAB_LIST[1].id} forceRender>
          {isError ? (
            <ErrorPlaceholder message={errorMsg} getData={reload} />
          ) : (
            <>
              {isLoading ? (
                <div className="loading-field">
                  <CommonLoadingComp />
                </div>
              ) : (
                <ReserveByStorePanel
                  storeContent={
                    basicFormData.storeTimeStepData?.storeDataByStoreTab
                  }
                  dateContent={
                    basicFormData.storeTimeStepData?.reserveDateDataByStoreTab
                  }
                  onDateTimeChange={onDateItemChangeHandler}
                  reserveItems={reserveItems}
                />
              )}

              {((loadShopListEnded &&
                !basicFormData.storeTimeStepData?.storeDataByStoreTab) ||
                showEmpty) && (
                <div className="dates-empty-field">
                  <EmptyPlaceHolder />
                </div>
              )}

              {isUnsupportCity && <UnsupportCityHolder />}
            </>
          )}
        </TabPanel>
      </Tabs>
    </div>
  );
}
